/* eslint-disable react/jsx-pascal-case */
import Icon, { RedoOutlined, InstagramOutlined, FacebookOutlined, GlobalOutlined, } from '@ant-design/icons';
import { QRCode } from 'antd';
import { Form, Button, Input, Row, Col, Typography, Divider, message } from "../ui/ot";
import { Checkbox } from "../ui/checkbox"
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useRef } from 'react';
import OTLogo from './OTLogo';
import AILogo from './AILogo'
import VirtualKeyboard from '../ui/virtual_keyboard.jsx';
import { useTranslation } from "react-i18next";
import { RefreshCwIcon } from "lucide-react"

import Language from '../language';
const loginLanguage = Language?.component.children.login

const Login = ({
    logo = "AI",
    footerCopyRight = "人工智慧與產學合作中心", //澄欣科技股份有限公司
    IGurl = "",
    FBurl = "",
    LINEurl = "",
    Weburl = "",
    setting = {
        webSites: false,
        forgotPassword: false,
        forgotAccount: false,
        lineLogin: false,
        signAccount: false,
        rememberMe: true,
        language: false,
        chatting: false,
    },
    keyPrefix = 'component.login',
    defaultLogoInURL = "/",
    customSignup,
    onChangeLanguage = () => { }
}) => {
    const [currentTime, setCurrentTime] = useState(new Date())
    const formatDate = (date) => {
        return date.toLocaleDateString("zh-TW", { year: "numeric", month: "long", day: "numeric" })
    }

    const formatTime = (date) => {
        return date.toLocaleTimeString("zh-TW", { hour: "2-digit", minute: "2-digit" })
    }

    const getWeekday = (date) => {
        const weekdays = ["日", "一", "二", "三", "四", "五", "六"]
        return weekdays[date.getDay()]
    }
    const { t } = useTranslation('translation', { keyPrefix })

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date())
        }, 1000)

        return () => clearInterval(timer)
    }, [])
    return (
        <Row>
            <Col span={24}>
                <Row >
                    <Col span={24}
                    >
                        <div className="min-h-screen bg-gradient-to-br from-orange-100 to-orange-300 ">
                            {/* {
                                setting?.language
                                &&
                                <Col span={24}>
                                    <Row justify={"end"}>
                                        <Col>
                                            <Radio.Group
                                                // value={configContext.locale}
                                                onChange={(e) => onChangeLanguage(e.target.value)}>
                                                <Radio.Button key="en" value={en}>
                                                    English
                                                </Radio.Button>
                                                <Radio.Button key="cn" value={zh_TW}>
                                                    中文
                                                </Radio.Button>
                                            </Radio.Group>
                                        </Col>
                                    </Row>
                                </Col>} */}
                            <div className="flex items-center justify-center p-4">
                                <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-6xl w-full flex">
                                    <div className="w-full md:w-3/5 p-8">
                                        <LoginFrame
                                            defaultLogoInURL={defaultLogoInURL}
                                            setting={
                                                {
                                                    forgotPassword: true,
                                                    forgotAccount: true,
                                                    lineLogin: true,
                                                    signAccount: true,
                                                    ...setting
                                                }
                                            }
                                            logo={logo}
                                            customSignup={customSignup}
                                        />
                                    </div>
                                    <div className="hidden md:block w-2/5 bg-orange-100 p-8">
                                        <div className="h-full flex flex-col justify-between">
                                            <div>
                                                <h2 className="text-3xl font-bold text-orange-800 mb-4">{t('welcome_message')}</h2>
                                                {/* Date and Time */}
                                                <div className="bg-white rounded-lg p-4 mb-6 shadow">
                                                    <p className="text-xl font-semibold text-gray-800">{formatDate(currentTime)}</p>
                                                    <p className="text-3xl font-bold text-orange-600">{formatTime(currentTime)}</p>
                                                    <p className="text-lg text-gray-600">今天是星期{getWeekday(currentTime)}</p>
                                                </div>
                                            </div>

                                            {/* Login Tips */}
                                            <div className="bg-white rounded-lg p-4 shadow">
                                                <h3 className="text-xl font-semibold text-orange-800 mb-3">{t('login_prompt')}</h3>
                                                <ul className="space-y-2 text-sm text-gray-700">
                                                    <li>• {t('verify_account_password')}</li>
                                                    <li>• {t('captcha_refresh')}</li>
                                                    <li>• {t('public_computer_warning')}</li>
                                                    <li>• {t('forgot_password_instruction')}</li>
                                                    <li>• {t('enable_virtual_keyboard')}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Col span={24} className="p-4">
                                <Row justify="center">
                                    <Col span={24}>
                                        <Row justify="center">
                                            {setting?.webSites && <Col>
                                                <Row gutter={[8, 8]}>
                                                    <Col>
                                                        <InstagramOutlined
                                                            style={{
                                                                fontSize: '2rem',
                                                                // color:'#fff'
                                                            }}
                                                            onClick={() => {
                                                                window.open(IGurl, 'blank')
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <FacebookOutlined
                                                            style={{
                                                                fontSize: '2rem',
                                                                color: "#1a77f2"
                                                            }}
                                                            onClick={() => {
                                                                window.open(FBurl, 'blank')
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <LineIcon
                                                            style={{
                                                                fontSize: '2rem',
                                                                color: "#17b705"
                                                            }}
                                                            onClick={() => {
                                                                window.open(LINEurl, 'blank')
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <GlobalOutlined
                                                            style={{
                                                                fontSize: '2rem',
                                                                color: "#f5743b"
                                                            }}
                                                            onClick={() => {
                                                                window.open(Weburl, 'blank')
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>}
                                        </Row>
                                    </Col>
                                    <Col span={24} style={{ textAlign: "center" }}>
                                        {/* <Row justify="center"> */}
                                        {/* <Col> */}
                                        © Copyright 2025 {footerCopyRight}. All rights reserved.
                                        {/* </Col>
                                        </Row> */}
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>

    );
};
const LoginFrame = ({
    lineLogin = true,
    logo = "OT",
    setting = {
        forgotPassword: true,
        forgotAccount: true,
        lineLogin: true,
        signAccount: true,
        chatting: true,
        language: false,
        rememberMe: true
    },
    keyPrefix = 'component.login',
    defaultLogoInURL,
    field,
    customSignup
}) => {

    const { t } = useTranslation('translation', { keyPrefix })
    const [remember, setRemember] = useState(true)
    const line_login = lineLogin || false
    const [date_now] = useState(Date.now())
    const [refreshToken, setRefreshToken] = useState('')
    const [form] = Form.useForm();
    const line_login_ref = useRef(true);
    const [mode, setMode] = useState("login")
    const [forgotCodeRefreshToken, setForgotCodeRefreshToken] = useState('')
    const [reciprocalCount, setReciprocalCount] = useState(120)
    const [reciprocalID, setReciprocalID] = useState(null)
    const [forgotPasswordLevel, setForgotPasswordLevel] = useState("getUserInformation")
    const [username, setUsername] = useState(""); // 確保初始值是空字符串
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');
    const [activeInput, setActiveInput] = useState(null); // 控制小鍵盤的目標輸入框
    const [showKeyboard, setShowKeyboard] = useState(false); // 小鍵盤的顯示狀態
    const [loading, setLoading] = useState(false)

    const handleKeyPress = (value) => {
        console.log({ value })
        console.log({ activeInput })
        const prev = form.getFieldValue(activeInput) ?? '';
        if (value === 'delete') {
            form.setFieldsValue({ [activeInput]: prev.slice(0, -1) }) // 刪除最後一個字符
            return;
        }
        if (value === 'clear') {
            form.setFieldsValue({ [activeInput]: '' }) // 清空
            return;
        }
        form.setFieldsValue({ [activeInput]: prev + value }) // 拼接字符
    };

    const navigate = useNavigate();
    const onFinish = (values) => {
        localStorage.setItem("refresh_token", refreshToken.refresh_token)
        setLoading(true)
        axios.post('/login', {
            account: values.username,
            password: values.password,
            code: values.code,
            refresh_token: refreshToken.refresh_token
        })
            .then(response => {
                if(response.data?.status === "failed"){
                    openNotification('top', response.data.message)
                }else{
                    line_login_ref.current = false
                    navigate(response.data.href || `/warehousing/purchase`);
                    localStorage.setItem("refresh_token", response.data.refresh_token)
                    localStorage.setItem("lineBind", true)
                    if (!!defaultLogoInURL) {
                        navigate(defaultLogoInURL);
                    }
                    else {
                        navigate(response.data.href);
                    }
                }
            })
            .catch(error => {
                openNotification('top', '帳號或是密碼輸入錯誤 請再試一次')
            })
            .finally(() => {
                setLoading(false)
            })

    };
    const onForgotUid = (values) => {
        axios.post('/home/user/forgot_uid', {
            ...values,
            code: values.code,
            refresh_token: forgotCodeRefreshToken?.refresh_token
        })
            .then(response => {
                if (response.data?.status === "success") {
                    message.success("已傳送至信箱中")
                    startCounting()

                }
                else {
                    let errorMessage = response.data?.message ? response.data?.message : ""
                    message.error(errorMessage)
                }
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }
    const onFinishForgotPassword = (value, level) => {
        console.log({ value, level })
        if (level === "getUserInformation") {
            let params = {
                ...value,
                staff_phone: value?.staff_phone ? value?.staff_phone : ""
            }
            axios
                .get('/home/user/forgot_password',
                    {
                        params
                    }
                )
                .then(response => {
                    let status = response.data?.status
                    let message = response.data?.message
                    if (response.data?.refresh_token) {
                        setForgotCodeRefreshToken(response.data)
                        setForgotPasswordLevel('editUserPassword')
                    }
                    if (status === "failure") {
                        message.error(message)
                    }
                })
                .finally(() => {
                    if (line_login_ref.current)
                        setTimeout(() => get_line_login(), 1000)
                })
        }
        else if (level === "editUserPassword") {
            let data = {
                ...value,
                refresh_token: forgotCodeRefreshToken.refresh_token
            }
            axios
                .post('/home/user/forgot_password', data

                )
                .then(response => {
                    let responseStatus = response.data?.status
                    let responseMessage = response.data?.message
                    if (responseStatus === "success") {
                        message.success("修改成功")
                        setMode('login')
                        setForgotPasswordLevel("getUserInformation")
                    }
                    else {
                        message.error(responseMessage)
                    }
                })
                .catch(() => {
                    message.error("修改失敗")
                })
                .finally(() => {

                })
        }
    }
    const openNotification = (placement, content) => {
        message.warning(content);

    };
    const downHandler = (value) => {
        if (value.code === "Enter") {
            form.submit()
        }
    }
    const get_line_login = () => {
        axios
            .get('/qrcode/login',
                {
                    params: {
                        result_code: date_now
                    }
                }
            )
            .then(response => {
                if (response.data?.refresh_token) {
                    line_login_ref.current = false
                    navigate(response.data.href || `/`);
                    localStorage.setItem("refresh_token", response.data.refresh_token)
                }

            })
            .finally(() => {
                if (line_login_ref.current)
                    setTimeout(() => get_line_login(), 1000)
            })
    }
    const getRefreshToken = (refresh_mode) => {
        axios
            .get('/refresh_token',
                {
                }
            )
            .then(response => {
                if (!refresh_mode) {
                    setRefreshToken(response.data)
                }
                else if (refresh_mode === "forgotCodeRefreshToken") {
                    setForgotCodeRefreshToken(response.data)
                }
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }
    const onRememberChange = (remember) => {
        setRemember(pre => remember)
        let item = form.getFieldsValue()
        if (remember) {
            localStorage.setItem("username", item?.username)
            localStorage.setItem("password", item?.password)
        }
        else {
            localStorage.removeItem("username")
            localStorage.removeItem("password")
        }
    }
    const onRememberLoading = () => {
        let username = localStorage.getItem("username")
        let password = localStorage.getItem("password")
        if (username && password) {
            console.log("true")
            setRemember(pre => true)
            form.setFieldsValue({
                username: username,
                password: password
            })
        }
        else {
            setRemember(pre => false)
        }
    }
    const startCounting = () => {
        let countID = setInterval(() => {
            setReciprocalCount(pre => pre - 1)
        }, 1000)
        setReciprocalID(countID)
    }
    const stopCounting = () => {
        clearInterval(reciprocalID)
        setReciprocalCount(120)
    }
    const cleanUp = () => {
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('lineBind');
        axios.post('/logout').then(() => { }).catch(console.error);
    }
    useEffect(() => {
        cleanUp()
        if (setting?.lineLogin) {
            get_line_login()
        }
        getRefreshToken()
        document.title = "登入"
        onRememberLoading()
        window.addEventListener("keydown", downHandler);
        return () => {
            window.removeEventListener("keydown", downHandler);
            stopCounting()
        };
    }, [])
    useEffect(() => {
        form.resetFields()
        if (mode === "forgotUsername" || mode === "forgotPassword") {
            getRefreshToken("forgotCodeRefreshToken")
        }
        if (mode !== "forgotUsername") {
            stopCounting()
        }

    }, [mode])
    useEffect(() => {
        if (reciprocalCount === 0) {
            stopCounting()
        }

    }, [reciprocalCount])
    return (
        <Row gutter={[16, 32]}>

            <Col
                span={24}
            >
                {
                    logo === "OT" && <img
                        preview={false} src={OTLogo}
                    >
                    </img>
                }
                {
                    logo === "AI" && <img
                        preview={false} src={AILogo}
                    >
                    </img>
                }
                {
                    logo !== "AI" && logo !== "OT" && <Typography.Title>
                        {logo}
                    </Typography.Title>
                }
            </Col>
            {
                mode === "login" &&
                (<Col span={24}>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        form={form}
                    >
                        <Row gutter={[4, 4]}>
                            <Col
                                xxl={24}
                                xl={24}
                                lg={24}
                                md={24}
                                sm={24}
                                xs={24}
                            >
                                <Row gutter={[4, 4]}>
                                    <Col span={24}>
                                        <div className="space-y-2">
                                            <Form.Item
                                                {...field}
                                                name={[field?.name ?? '', 'username']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t("enter_account_name"),
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    id="username"
                                                    placeholder={t("enter_account")}
                                                    className="border-gray-200 focus:border-blue-500 transition-all"
                                                    onFocus={() => setActiveInput('username')}
                                                    readOnly={showKeyboard}
                                                />
                                            </Form.Item>
                                        </div>


                                        <div className="space-y-2">
                                            <Form.Item
                                                {...field}
                                                name={[field?.name ?? '', 'password']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t("enter_password"),
                                                    },
                                                ]}
                                            >
                                                <Input.Password
                                                    placeholder={t("enter_password_short")}
                                                    className=" border-gray-200 focus:border-blue-500 transition-all"
                                                    onFocus={() => setActiveInput('password')}
                                                    readOnly={showKeyboard}
                                                />
                                            </Form.Item>


                                        </div>
                                        <div className="flex space-x-2">
                                            <Form.Item
                                                {...field}
                                                name={[field?.name ?? '', 'code']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t("enter_verification_code"),
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t("enter_verification_code")}
                                                    className=" border-gray-200 focus:border-blue-500 transition-all"
                                                    onFocus={() => setActiveInput('code')}
                                                    readOnly={showKeyboard}
                                                />
                                            </Form.Item>
                                            <VerificationCode
                                                codeSrc={refreshToken?.code}
                                                getRefreshToken={getRefreshToken}
                                            />
                                        </div>
                                        <Row gutter={[0, 16]}>
                                            <Col span={24}>
                                                <Row justify="space-between">
                                                    <Col>
                                                        <div className="flex items-center space-x-2">
                                                            <Checkbox
                                                                id="remember"
                                                                checked={remember}
                                                                onCheckedChange={(checked) => onRememberChange(checked)}
                                                            // className="data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600"
                                                            />
                                                            <label
                                                                htmlFor="remember"
                                                                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                                                            >
                                                                {t("remember_me")}
                                                            </label>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <Button
                                                            htmlType='button'
                                                            onClick={() => setShowKeyboard(!showKeyboard)}
                                                        >
                                                            {showKeyboard ? t("close_keypad") : t("open_keypad")}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={24}>
                                                <Row gutter={[8, 8]}>
                                                    <Col span={24}>
                                                        <Button
                                                            loading={loading}
                                                            onClick={() => form.submit()}
                                                            block={true}
                                                        >
                                                            {t('login')}
                                                        </Button>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Row justify="center">
                                                            {setting?.forgotAccount && <Col>
                                                                <Button
                                                                    onClick={() => setMode("forgotUsername")}
                                                                    variant="link" className="text-sm text-orange-600 hover:text-orange-800 ml-1"
                                                                >
                                                                    {t("forgot_account")}
                                                                </Button>
                                                            </Col>}
                                                            {setting?.forgotPassword && <Col>
                                                                <Button
                                                                    onClick={() => setMode("forgotPassword")}
                                                                    variant="link" className="text-sm text-orange-600 hover:text-orange-800 ml-1"
                                                                >
                                                                    {t("forgot_password")}
                                                                </Button>

                                                            </Col>}

                                                        </Row>
                                                    </Col>
                                                    <Col span={24}>
                                                        {
                                                            setting?.signAccount &&
                                                            (
                                                                <div className=" text-center">
                                                                    <span className="text-sm text-gray-600">
                                                                        {t("no_account_yet")}
                                                                    </span>
                                                                    <Button
                                                                        onClick={() => setMode("signUp")}
                                                                        variant="link" className="text-sm text-orange-600 hover:text-orange-800 ml-1"
                                                                    >
                                                                        {t("register_now")}
                                                                    </Button>
                                                                </div>
                                                            )
                                                        }
                                                    </Col>

                                                </Row>

                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Divider />
                            </Col>
                            {setting?.lineLogin && (
                                <Col span={24} >
                                    <Row gutter={[8, 8]}
                                        justify={"center"}
                                    >
                                        <Col span={24}>
                                            <Row gutter={[8, 8]}
                                                justify={"center"}
                                            >
                                                <Col>
                                                    <Typography.P>
                                                        {t('QRcode_login_message')}{t('need_bind_message')}
                                                    </Typography.P>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <QRCode
                                                value={'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1661200200&redirect_uri=http%3A%2F%2F192.168.11.125%3A3000%2Fline_login&state=' + date_now + '&scope=profile%20openid&nonce=' + date_now}
                                            />
                                        </Col>


                                    </Row>

                                </Col>
                            )}
                        </Row>
                    </Form>
                    {/* 小鍵盤 */}
                    {showKeyboard && <VirtualKeyboard onKeyPress={handleKeyPress} />}
                </Col>)
            }
            {
                mode === "signUp" &&
                (customSignup === undefined ?
                    (<Col span={24}>
                        <Form
                            name="normal_login"
                            className="login-form"
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onFinish}
                            form={form}
                            labelCol={{
                                span: 6
                            }}
                            wrapperCol={{
                                span: 12
                            }}
                            autoComplete='off'
                        >
                            <Row gutter={[4, 4]}>
                                <Col
                                    xxl={24}
                                    xl={24}
                                    lg={24}
                                    md={24}
                                    sm={24}
                                    xs={24}
                                >
                                    <Row gutter={[4, 4]}>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('account_name')}
                                                name="username"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_account_name'),
                                                    },
                                                ]}
                                                autoComplete="off"
                                            >
                                                <Input placeholder={t('account_name')} />
                                            </Form.Item>
                                        </Col>

                                        <Col span={24}>
                                            <Col >
                                                <Form.Item
                                                    label={t('password')}
                                                    name="password"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t('enter_password'),
                                                        },
                                                    ]}
                                                >
                                                    <Input.Password
                                                        placeholder={t('password')}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Col>
                                        <Col span={24}>

                                            <Form.Item
                                                name="confirm"
                                                label={t('confirm_password')}
                                                dependencies={['password']}
                                                hasFeedback
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_confirm_password'),
                                                    },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error(t('password_mismatch')));
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input.Password />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('email')}
                                                name="email"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_email'),
                                                    },
                                                    {
                                                        type: 'email',
                                                        message: t('invalid_email_format'),
                                                    },

                                                ]}
                                            >
                                                <Input
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('phone')}
                                                name="cellphone"
                                            >
                                                <Input
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={[8, 8]}
                                justify="center"
                            >
                                <Col span={12}>
                                    <Button
                                        onClick={() => setMode("login")}
                                        block
                                    >
                                        {t('return_to_login')}
                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button
                                        type="default"
                                        // onClick={() => form.submit()}
                                        block={true}
                                    >
                                        {t('confirm_registration')}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>) :
                    <>
                        {React.cloneElement(customSignup, {
                            propsOnFormFinish: () => setMode("login"),
                            toolBarRender: () => [
                                <>
                                    <Button
                                        onClick={() => setMode("login")}
                                        block
                                    >
                                        {t('return_to_login')}
                                    </Button>
                                </>
                            ]
                        })}
                    </>)
            }
            {
                mode === "forgotUsername" &&
                (<Col span={24}>
                    <Row justify={"center"}>
                        <Col span={24} >
                            <Typography.Title level={4}>
                                {t('forgot_account_info')}
                            </Typography.Title>
                        </Col>

                        <Col span={24}>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onForgotUid}
                                form={form}
                                labelCol={{
                                    span: 6
                                }}
                                wrapperCol={{
                                    span: 12
                                }}
                                autoComplete='off'
                            >
                                <Row gutter={[4, 4]}>
                                    <Col
                                        xxl={24}
                                        xl={24}
                                        lg={24}
                                        md={24}
                                        sm={24}
                                        xs={24}
                                    >
                                        <Row gutter={[4, 4]}>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={t('email')}
                                                    name="user_email"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t('enter_email'),
                                                        },
                                                        {
                                                            type: 'email',
                                                            message: t('invalid_email_format'),
                                                        },

                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={t('phone')}
                                                    name="staff_phone"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t('enter_phone_number'),
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col
                                                xxl={24}
                                                xl={24}
                                                lg={24}
                                                md={24}
                                                sm={24}
                                                xs={24}
                                            >
                                                <Form.Item
                                                    label={t('verification_code')}
                                                    name="code"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: t('enter_verification_code'),
                                                        },
                                                    ]}
                                                >

                                                    <Input
                                                        type="text"
                                                        placeholder={t('verification_code')}
                                                        autoComplete={"off"}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Row>

                                                    <Col >
                                                        <img style={{ "height": "50px" }} class="input-group-addon" src={`${forgotCodeRefreshToken?.code}`} id="code_pic" />
                                                    </Col>
                                                    <Col>
                                                        <Button
                                                            onClick={() => getRefreshToken("forgotCodeRefreshToken")}
                                                            icon={<RedoOutlined />}
                                                            type='link'>
                                                            {t('reorganize')}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>

                                        </Row>
                                    </Col>
                                </Row>

                            </Form>
                        </Col>

                        <Col span={24}>
                            <Row gutter={[8, 8]}
                                justify="center"
                            >
                                <Col span={24}>
                                    {reciprocalCount !== 120 &&
                                        <Typography.Title level={5}>

                                            {t('resend_verification_code')}
                                        </Typography.Title>
                                    }

                                </Col>
                                <Col span={12}>
                                    <Button
                                        onClick={() => setMode("login")}
                                        block
                                    >
                                        {t('return_to_login')}

                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button

                                        type="default"
                                        onClick={() => form.submit()}
                                        block={true}
                                        disabled={reciprocalCount !== 120}
                                    >
                                        {t('return_to_login')}
                                        {reciprocalCount !== 120 && `(${reciprocalCount})`}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>)
            }
            {
                mode === "forgotPassword" &&
                (<Col span={24}>
                    <Row justify={"center"}>
                        <Col span={24}>
                            <Typography.Title level={4}>
                                {forgotPasswordLevel === "getUserInformation"
                                    ? t('forgot_password_info') :
                                    t('enter_verification_code_and_reset_password')}
                            </Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={(values) => onFinishForgotPassword(values, forgotPasswordLevel)}
                                form={form}
                                labelCol={{
                                    span: 6
                                }}
                                wrapperCol={{
                                    span: 12
                                }}
                                autoComplete='off'
                            >
                                {
                                    forgotPasswordLevel === "getUserInformation" &&
                                    <Row gutter={[4, 4]}>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('account_name')}
                                                name="user_uid"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_account_name'),
                                                    },
                                                ]}
                                                autoComplete="off"
                                            >
                                                <Input placeholder={t('enter_account_name')} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('email')}
                                                name="user_email"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_email'),
                                                    },
                                                    {
                                                        type: 'email',
                                                        message: t('invalid_email_format'),
                                                    },

                                                ]}
                                            >
                                                <Input
                                                    placeholder="EX:XXX@mail.com"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('phone')}
                                                name="staff_phone"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: '請輸入手機號碼',
                                            //     },
                                            // ]}
                                            >
                                                <Input
                                                    placeholder="EX:09xxxxxxxx"

                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                }
                                {
                                    forgotPasswordLevel === "editUserPassword" &&
                                    <Row gutter={[4, 4]}>
                                        <Col span={24}>
                                            <Form.Item
                                                hidden={true}
                                                label={t('account_name')}
                                                name="user_uid"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_account_name')
                                                    },
                                                ]}
                                                autoComplete="off"
                                            >
                                                <Input placeholder={t('enter_account_name')} />
                                            </Form.Item>
                                        </Col>
                                        <Col
                                            xxl={24}
                                            xl={24}
                                            lg={24}
                                            md={24}
                                            sm={24}
                                            xs={24}
                                        >
                                            <Form.Item
                                                label={t('verification_code')}
                                                name="code"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('enter_verification_code'),
                                                    },
                                                ]}
                                            >

                                                <Input
                                                    type="text"
                                                    placeholder={t('verification_code')}
                                                    autoComplete={"off"}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('new_password')}
                                                name="password"
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                ]}
                                                autoComplete="off"

                                            >
                                                <Input.Password />
                                            </Form.Item>


                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('confirm_new_password')}
                                                name="password1"
                                                dependencies={['password']}
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error(t('password_mismatch')));
                                                        },
                                                    }),
                                                ]}
                                            >
                                                <Input.Password />
                                            </Form.Item>
                                        </Col>

                                    </Row>
                                }


                            </Form>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[8, 8]}
                                justify="center"
                            >
                                <Col span={12}>
                                    <Button
                                        onClick={() => setMode("login")}
                                        block
                                    >
                                        {t('return_to_login')}
                                    </Button>
                                </Col>
                                <Col span={12}>
                                    <Button
                                        type="default"
                                        onClick={() => form.submit()}
                                        block={true}

                                    >
                                        {t('submit')}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Col>)

            }

        </Row>
    )
}
const LineIcon = ({
    style = {
    },
    onClick = () => {

    }
}) => (
    <Icon
        onClick={onClick}
        style={{
            ...style
        }}
        component={LineSvg}
    />
)
const LineSvg = ({
    width = "1rem",
    height = "1rem",
    color = "#17b705"
}) => (
    <svg t="1692807712061"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4251"
        id="mx_n_1692807712061"
        width={width}
        height={height}
        fill={color}
    >
        <path
            d="M826.24 420.821333a26.922667 26.922667 0 0 1 0 53.802667H751.36v48h74.88a26.88 26.88 0 1 1 0 53.717333h-101.802667a26.922667 26.922667 0 0 1-26.752-26.837333V345.941333c0-14.72 12.032-26.88 26.88-26.88h101.802667a26.88 26.88 0 0 1-0.128 53.76H751.36v48h74.88z m-164.48 128.682667a26.88 26.88 0 0 1-26.922667 26.752 26.368 26.368 0 0 1-21.76-10.666667l-104.234666-141.525333v125.44a26.88 26.88 0 0 1-53.632 0V345.941333a26.752 26.752 0 0 1 26.624-26.794666c8.32 0 16 4.437333 21.12 10.837333l105.045333 142.08V345.941333c0-14.72 12.032-26.88 26.88-26.88 14.72 0 26.88 12.16 26.88 26.88v203.562667z m-244.949333 0a26.965333 26.965333 0 0 1-26.922667 26.837333 26.922667 26.922667 0 0 1-26.752-26.837333V345.941333c0-14.72 12.032-26.88 26.88-26.88 14.762667 0 26.794667 12.16 26.794667 26.88v203.562667z m-105.216 26.837333H209.792a27.050667 27.050667 0 0 1-26.88-26.837333V345.941333c0-14.72 12.16-26.88 26.88-26.88 14.848 0 26.88 12.16 26.88 26.88v176.682667h74.922667a26.88 26.88 0 0 1 0 53.717333M1024 440.064C1024 210.901333 794.24 24.405333 512 24.405333S0 210.901333 0 440.064c0 205.269333 182.186667 377.258667 428.16 409.941333 16.682667 3.498667 39.381333 11.008 45.141333 25.173334 5.12 12.842667 3.370667 32.682667 1.621334 46.08l-6.997334 43.52c-1.92 12.842667-10.24 50.602667 44.757334 27.52 55.082667-22.997333 295.082667-173.994667 402.602666-297.6C988.842667 614.101333 1024 531.541333 1024 440.064"
            p-id="4252">
        </path>
    </svg>
)
const VerificationCode = ({
    codeSrc = null,
    getRefreshToken
}) => {
    return (
        <div className="flex  ">
            <div
                className="flex h-10 min-w-[100px] items-center justify-center rounded-md px-3 font-mono text-sm font-bold tracking-wider overflow-hidden relative"

            >
                {/* Noise pattern overlay */}
                <div
                    className="absolute inset-0  "
                    style={{
                        backgroundImage: `url(${codeSrc})`,
                    }}
                ></div>

            </div>
            <Button
                block
                variant="text"
                onClick={() => getRefreshToken()}
                type="button"
                className="ml-1 bg-white/80 hover:bg-white transition-colors"
            >
                <RefreshCwIcon className="h-4 w-4 text-blue-600" />
                <span className="sr-only">刷新驗證碼</span>
            </Button>
        </div>
    )
}
export default Login;
export { LoginFrame, VerificationCode }